import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import { ShowHeader } from "@/common/components/ShowHeader";
import Tabs from "@/common/components/Tabs";
import useBillingBill from "@/common/hooks/queries/useBillingBill";
import { useParams } from "react-router-dom";
import { billingBillTabs } from "../../constants/tabs.constant";
import BillDateTitleWithTimezone from '@/common/components/BillDateTitleWithTImezone';

const BillingBillsShow = () => {
  const { id } = useParams();

  const {
    data: bill,
    error: billError = {} as any,
    refetch: billRefetch,
  } = useBillingBill({ id });

  return (
    <div>
      <ShowHeader
        backTo="/billing-bills"
        LogoPlaceholder={<></>}
        titleClassName="text-nowrap font-medium text-lg"
        title={(
          <div className='flex items-center gap-1'>
            <p>
              Fatura {bill?.number} 
            </p>

            <BillDateTitleWithTimezone
              startDate={bill?.opened_at}
              endDate={bill?.closed_at}
              timezone={bill?.time_zone}
            />
          </div>
        )}
      />

      <ErrorMessageWrapper
        className="max-h-[calc(100vh-128px)]"
        statusCode={billError?.status}
        refetchFunction={billRefetch}
      >
        <Tabs
          tabsListClassName="w-full bg-transparent rounded-none"
          tabsTriggerClassName="h-8 w-full rounded-none border-b border-[#444444] text-white-800 text-xs data-[state=active]:bg-transparent data-[state=active]:text-white-800 data-[state=active]:shadow-none data-[state=active]:border-blue-800"
          tabsContentClassName="mt-6"
          tabsList={billingBillTabs}
        />
      </ErrorMessageWrapper>
    </div>
  );
};

export default BillingBillsShow;
